import { render, staticRenderFns } from "./DepartAuthModal.vue?vue&type=template&id=138a3f2a&scoped=true"
import script from "./DepartAuthModal.vue?vue&type=script&lang=js"
export * from "./DepartAuthModal.vue?vue&type=script&lang=js"
import style0 from "./DepartAuthModal.vue?vue&type=style&index=0&id=138a3f2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138a3f2a",
  null
  
)

export default component.exports